import axios from 'axios'
import { cancelSource } from '@/utils/axios-helper'

const addCancelToken = (request) => {
  request.cancelToken = cancelSource.token
  return request
}

const HttpConfig = {
  install () {
    axios.interceptors.request.use(
      request => addCancelToken(request)
    )
    axios.interceptors.response.use(
      response => response.data
    )

    axios.defaults.timeout = 60000
  }
}

export default HttpConfig